import { app, Component, payload, ojs, state, v } from "modular-openscriptjs";
import { dom } from "../../fotastart";
import { pageInfo, redirect } from "../../helpers";
import { PAGES } from "../../declarations";

const h = app("h");
const broker = app("broker");
const $e = app("$e");

export default class LoginPage extends Component {
	emailId = "login-email-input";
	passwordId = "login-password-input";
	rememberMeId = "login-remember-me-checkbox";
	btnId = "login-submit-btn";
	showEmailForm = state(false);
	showPassword = state(false);

	render(...args) {
		pageInfo(PAGES.LOGIN);

		return h.div(
			{
				class: "min-vh-100 d-flex align-items-center justify-content-center bg-light",
			},
			h.div(
				{
					class: "card border-0 shadow-sm p-4 p-md-5",
					style: "max-width: 450px; width: 100%; border-radius: 20px;",
				},

				// Header
				h.div(
					{ class: "text-center mb-4" },
					h.h2(
						{ class: "fw-bold mb-2", style: "color: #010101;" },
						"Welcome Back"
					)
				),

				// Form
				h.form(
					{ class: "d-flex flex-column gap-3" },

					// Google Login (Top Priority)
					h.div(
						{ class: "d-flex justify-content-center" },
						h.button(
							{
								type: "button",
								class: "btn-google btn-google-dark btn-google-pill",
								onclick: h.func(
									"fireEvent",
									$e.user.needs.googleLogin
								),
							},
							h.span({ class: "btn-state" }),
							h.span(
								{ class: "btn-icon" },
								h.$svg(
									h.$use({ href: "#google_G" })
								)
							),
							h.span(
								{ class: "btn-text" },
								"Sign in with Google"
							)
						)
					),

					// Divider
					h.div(
						{
							class: "d-flex align-items-center py-2",
							style: "--or-width: 36px;"
						},
						h.hr({
							class: "border-secondary opacity-10",
							style: "width: calc((100% - var(--or-width)) / 2);"
						}),
						h.small(
							{
								class: "text-muted text-uppercase text-center fw-500",
								style: "width: var(--or-width);"
							},
							"or"
						),
						h.hr({
							class: "border-secondary opacity-10",
							style: "width: calc((100% - var(--or-width)) / 2);"
						})
					),

					// Email/Password Toggle or Form
					v(this.showEmailForm, () =>
						this.showEmailForm.value
							? this.renderEmailForm()
							: h.div(
								{ class: "d-flex justify-content-center" },
								h.button(
									{
										type: "button",
										class: "btn btn-outline-dark rounded-pill d-inline-flex align-items-center",
										style: "height: var(--google-btn-height); gap: var(--google-btn-spacer);",
										onclick: this.method("toggleEmailForm"),
									},
									h.span(
										{ class: "btn-icon" },
										h.$svg(
											{ width: 24, height: 24 },
											h.$use({ href: "#gms_mail" })
										)
									),
									h.span(
										{ class: "btn-text" },
										"Sign in with Email & Password"
									)
								)
							)
					)
				),



				// Back to Home
				h.div(
					{ class: "text-center mt-4" },
					h.a(
						{
							href: "#",
							class: "text-muted small text-decoration-none fw-500",
							onclick: "app('router').to('home')",
						},
						"← Back to Home"
					)
				)
			),
			...args
		);
	}

	renderEmailForm() {
		return h.div(
			{ class: "d-grid gap-3" },

			// Back button
			h.button(
				{
					type: "button",
					class: "btn btn-link text-start p-0 text-decoration-none",
					style: "color: #973e87;",
					onclick: this.method("toggleEmailForm"),
				},
				h.i({ class: "fa-solid fa-arrow-left me-2" }),
				"Back to options"
			),

			// Email
			h.div(
				{ class: "form-field" },
				h.label(
					{
						for: this.emailId,
						class: "form-label fw-600 small text-uppercase text-muted",
					},
					"Email Address"
				),
				h.input({
					class: "form-control form-control-lg bg-light border-0",
					type: "email",
					id: this.emailId,
					placeholder: "name@example.com",
					style: "font-size: 0.95rem;",
				})
			),

			// Password
			h.div(
				{ class: "form-field" },
				h.div(
					{
						class: "d-flex justify-content-between align-items-center mb-1",
					},
					h.label(
						{
							for: this.passwordId,
							class: "form-label fw-600 small text-uppercase text-muted mb-0",
						},
						"Password"
					),
					h.a(
						{
							href: "#",
							class: "text-decoration-none small fw-600",
							style: "color: #973e87;",
							onclick: "route.to('user.forgot-password')",
						},
						"Forgot password?"
					)
				),
				h.div(
					{ class: "input-group" },
					v(
						this.showPassword,
						(visible) =>
							h.input({
								class: "form-control form-control-lg bg-light border-0 d-block",
								type: visible.value ? "text" : "password",
								id: this.passwordId,
								placeholder: "Enter your password",
								style: "font-size: 0.95rem; border-top-right-radius: 0; border-bottom-right-radius: 0;",
							}),
						{ $class: "flex-fill" }
					),
					h.button(
						{
							class: "btn btn-light border-0 text-muted",
							type: "button",
							onclick: this.method("togglePasswordVisibility"),
							style: "background-color: #f8f9fa; border-top-left-radius: 0; border-bottom-left-radius: 0;",
						},
						v(this.showPassword, (visible) =>
							h.i({
								class: visible.value
									? "fa-solid fa-eye-slash"
									: "fa-solid fa-eye",
							})
						)
					)
				)
			),

			// Remember Me
			h.div(
				{ class: "form-check" },
				h.input({
					class: "form-check-input",
					type: "checkbox",
					id: this.rememberMeId,
					style: "cursor: pointer;",
				}),
				h.label(
					{
						class: "form-check-label text-muted small",
						for: this.rememberMeId,
						style: "cursor: pointer;",
					},
					"Keep me signed in"
				)
			),

			// Login Button
			h.button(
				{
					type: "button",
					id: this.btnId,
					class: "btn btn-primary rounded-pill shadow-sm mt-2",
					onclick: this.method("doLogin", ["${this}"]),
				},
				"Sign In"
			)
		);
	}

	toggleEmailForm() {
		this.showEmailForm.value = !this.showEmailForm.value;
	}

	togglePasswordVisibility() {
		this.showPassword.value = !this.showPassword.value;
		// Maintain focus on input
		setTimeout(() => dom.id(this.passwordId)?.focus(), 0);
	}

	doLogin(button) {
		button.disabled = true;
		const originalText = button.innerText;
		button.innerHTML =
			'<i class="fas fa-spinner fa-spin me-2"></i> Signing in...';
		button.dataset.originalText = originalText;

		broker.send(
			$e.user.needs.emailLogin,
			payload(
				{
					email: dom.id(this.emailId)?.value,
					password: dom.id(this.passwordId)?.value,
					rememberMe: dom.id(this.rememberMeId)?.checked,
				},
				{ id: button.id }
			)
		);
	}

	$$user = {
		authenticated: (ed, event) => {
			if (app("router").is("user.login")) {
				redirect().to("index");
			}
		},

		has: {
			emailLoginError: (ed, event) => {
				// Re-enable button
				const btn = dom.id(this.btnId);
				if (btn) {
					btn.disabled = false;
					btn.innerText = "Sign In";
				}
			},
		},
	};
}
